import { createActions, handleActions } from 'redux-actions';
import { fromJS } from 'immutable';

const defaultAuthState = {
    initializing: true,
    user: null,
};

const authActions = createActions({
    FIREBASE: {
        AUTH: {
            SIGN_IN: (user) => ({ user }),
            SIGN_OUT: () => ({}),
        },
    },
});

export const firebaseAuthReducer = handleActions({
    [authActions.firebase.auth.signIn]: (state, { payload: { user } }) => state.set('user', user).set('initializing', false),
    [authActions.firebase.auth.signOut]: (state) => state.set('user', null).set('initializing', false),
}, fromJS(defaultAuthState));

export const createFirebaseAuthMiddleware = (firebase) => {
    let unsubscribe = null;
    const subscribe = (store) => {
        if (unsubscribe === null) {
            unsubscribe = firebase.auth().onAuthStateChanged(user => {
                /* @@ */
                console.log('authStateChanged', user);
                /* ## */
                if (user === null) {
                    store.dispatch(authActions.firebase.auth.signOut());
                } else {
                    store.dispatch(authActions.firebase.auth.signIn(user));
                }
            });
        }
    };

    return store => next => action => {
        subscribe(store);
        return next(action);
    };
};



// WEBPACK FOOTER //
// ./src/redux/modules/firebase/authModule.js